import Header from "./Header";

export default function AccountWrapper({ children }) {
  return (
    <div className="overview-wrapper">
      <Header />
      {children}
    </div>
  );
}
